/** Set true to show rainfall / rain-sensor UI again. */
export const SHOW_RAINFALL = false;
